module.exports={TICKET:{STARTING_FROM:"Tickets kaufen"},G8:{COUNTDOWN:"{{remaining}}</1>"}};